import React from "react";
import InventoryCatalogueView from "../features/pricing/views/InventoryCatalogueView";

const InventoryCataloguePage = () => <InventoryCatalogueView />;

export default InventoryCataloguePage;
